interface Props {
  status: string;
}

const InquiryStatusBadge = ({ status }: Props) => {
  return (
    <span className={`glazing-status-badge ${status.toLowerCase().replace(" ", "-")}`}>
      {status}
    </span>
  );
};

export default InquiryStatusBadge;
